module.exports = __webpack_public_path__ + "static/img/logo_t.3c78143.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_t.jpg
// module id = IIH9
// module chunks = 2